module.exports = __webpack_public_path__ + "static/feature-time-reports-3c080da045d0117b821dc255d1677d6c.png";